import styled from "styled-components";
import { Link } from "react-router-dom";

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #f7f8f9;
  display: flex;
  color: #1e2228;
`;

export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  padding: 0 36px;
  background-color: #f7f8f9 !important;
  overflow: scroll;
`;